<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import FileUpload from "./uploads/FileUpload.vue";
import Multiselect from "@vueform/multiselect/dist/multiselect.vue2.js";
import InlineFileUpload from "./uploads/InlineFileUpload.vue";
import FloatingButton from "../../floating-button/FloatingButton.vue";
import floppyDisk from "../../../../static/assets/images/floppy-disk.svg";
import filePdfIcon from "../../../../static/assets/images/file-pdf-solid.svg";
import fileWordIcon from "../../../../static/assets/images/file-word-solid.svg";

export default {
  name: "StartTab",
  data() {
    return {
      floppyDisk,
      filePdfIcon,
      fileWordIcon,
      active: false,
      selectedColor: "",
      id: this.$route.params.id ? this.$route.params.id : null,
      openUploadModal: false,
      editPortrait: false,
      editLandscape: false,
    };
  },
  components: {
    FileUpload,
    Multiselect,
    InlineFileUpload,
    FloatingButton,
  },
  computed: {
    ...mapGetters({
      currentActivity: "warmups/currentActivity",
      seriesOptions: "warmups/seriesOptions",
      coloursOptions: "warmups/coloursOptions",
      fieldOptionsChunked: "warmups/fieldOptionsChunked",
      startTabErrors: "warmups/startTabErrors",
    }),
    series: {
      set(value) {
        this.$store.commit("warmups/setActivityField", {
          fieldName: "series",
          value,
        });
      },
      get() {
        if (this.currentActivity) {
          return this.currentActivity.series;
        }
        return "";
      },
    },
    file: {
      set(value) {
        this.$store.commit("warmups/setActivityField", {
          fieldName: "file",
          value,
        });
      },
      get() {
        if (this.currentActivity) {
          return this.currentActivity.file;
        }
        return "";
      },
    },
    landscape_file: {
      set(value) {
        this.$store.commit("warmups/setActivityField", {
          fieldName: "landscape_file",
          value,
        });
      },
      get() {
        if (this.currentActivity) {
          return this.currentActivity.landscape_file;
        }
        return "";
      },
    },
    series_state() {
      return this.currentActivity.series ? true : false;
    },
    series_errors() {
      if (this.startTabErrors.series != null) {
        return this.startTabErrors.series.join("<br/>");
      }
      return "";
    },
    working_title: {
      set(value) {
        this.$store.commit("warmups/setActivityField", {
          fieldName: "working_title",
          value,
        });
      },
      get() {
        if (this.currentActivity) {
          return this.currentActivity.working_title;
        }
        return "";
      },
    },
    working_title_state() {
      return this.currentActivity.working_title != "" &&
        this.currentActivity.working_title.length <= 250 &&
        !this.startTabErrors.working_title
        ? true
        : false;
    },
    working_title_errors() {
      if (this.startTabErrors.working_title != null) {
        return this.startTabErrors.working_title.join("<br/>");
      }
      return "";
    },
    historical_name: {
      set(value) {
        this.$store.commit("warmups/setActivityField", {
          fieldName: "historical_name",
          value,
        });
      },
      get() {
        if (this.currentActivity) {
          return this.currentActivity.historical_name;
        }
        return "";
      },
    },
    filming_complete: {
      set(value) {
        this.$store.commit("warmups/setActivityField", {
          fieldName: "filming_complete",
          value,
        });
      },
      get() {
        if (this.currentActivity) {
          return this.currentActivity.filming_complete;
        }
        return "";
      },
    },
    colour: {
      set(value) {
        this.$store.commit("warmups/setActivityField", {
          fieldName: "colour",
          value,
        });
      },
      get() {
        if (this.currentActivity) {
          return this.currentActivity.colour;
        }
        return "";
      },
    },
    colour_state() {
      return !this.currentActivity.colour ? true : false;
    },
    selector: function () {
      const activeColour = this.findColor();
      if (activeColour) {
        return '<span style="background: ' + activeColour.value + '"></span> ';
      } else {
        return "Select Colour";
      }
    },
    getFileType() {
      if (this.hasExtension([".pdf"])) {
        return "pdf";
      }
      if (this.hasExtension([".doc", ".docx"])) {
        return "doc";
      }
      return "image";
    },
  },
  methods: {
    hasExtension(exts) {
      return new RegExp("(" + exts.join("|").replace(/\./g, "\\.") + ")$").test(
        this.currentActivity.file
      );
    },
    addSeries() {
      if (this.currentActivity.series) {
        var srs = this.seriesOptions.find(
          (series) => series.value == this.currentActivity.series
        );
        if (!srs) {
          var srs_val = this.currentActivity.series
            .toLowerCase()
            .replace(/ /g, "-")
            .replace(/[^\w-]+/g, "");

          const series = {
            value: srs_val,
            label: this.currentActivity.series,
            option_for: "SRS",
          };
          this.$store.dispatch("warmups/createSeries", series).then(
            (res) => {},
            (error) => {
              console.log(error);
            }
          );
        }
      }
    },
    createActivity() {
      this.$store.commit("commons/setPreloader", true);
      this.$store
        .dispatch("warmups/createEmptyActivity", this.currentActivity)
        .then(
          (res) => {
            this.getToasterResponse();
          },
          (error) => {
            console.log(error);
          }
        );
    },
    updateActivity() {
      this.$store.commit("commons/setPreloader", true);
      this.$store
        .dispatch("warmups/updateActivity", this.$route.params.id)
        .then(
          (res) => {
            this.getToasterResponse();
          },
          (error) => {
            console.log(error);
          }
        );
    },
    getToasterResponse() {
      if (this.startTabErrors.working_title) {
        this.$store.commit("commons/setPreloader", false);
        this.$store.commit(
          `commons/setSavingErrorMessage`,
          Array.isArray(this.startTabErrors.working_title)
            ? this.startTabErrors.working_title[0]
            : this.startTabErrors.working_title
        );
      } else if (this.startTabErrors.series) {
        this.$store.commit("commons/setPreloader", false);
        this.$store.commit(
          `commons/setSavingErrorMessage`,
          Array.isArray(this.startTabErrors.series)
            ? this.startTabErrors.series[0]
            : this.startTabErrors.series
        );
      } else if (this.startTabErrors.colour) {
        this.$store.commit("commons/setPreloader", false);
        Array.isArray(this.startTabErrors.colour)
          ? this.startTabErrors.colour[0]
          : this.startTabErrors.colour;
      }
      if (
        this.startTabErrors.working_title == null &&
        this.startTabErrors.series == null &&
        this.startTabErrors.colour == null
      ) {
        this.$store.commit(`commons/setSavingForm`, "Saved");
        this.tabStatus(false);
        this.$store.commit("commons/setPreloader", false);
      }
    },
    setColor: function (color) {
      this.colour = color.id;
      this.selectedColor = color.value;
      this.active = false;
    },
    toggleDropdown: function () {
      this.active = !this.active;
    },
    findColor: function () {
      var colourSelected = this.coloursOptions
        ? this.coloursOptions.find((option) => option.label == "Warm Up")
        : null;
      this.colour = colourSelected.id;
      return colourSelected;
    },
    showUploadModal() {
      this.openUploadModal = true;
    },
    handleFileUploaded(file) {
      this.file = file;
      this.editPortrait = false;
    },
    handleLandscapeFileUploaded(file) {
      this.landscape_file = file;
      this.editLandscape = false;
    },

    makeToast(variant = null, title, message) {
      this.$bvToast.toast(message, {
        title: `${title || "default"}`,
        variant: variant,
        solid: true,
        toaster: "b-toaster-bottom-right",
      });
    },

    editPortraitFunc() {
      this.editPortrait = true;
    },
    trashPortraitFunc() {
      this.editPortrait = true;
    },

    editLandscapeFunc() {
      this.editLandscape = true;
    },

    tabStatus(status) {
      console.log(status);
      this.$store.commit(`warmups/setTabStatus`, status);
    },
  },
  watch: {
    series() {
      this.tabStatus(true);
    },
    working_title() {
      this.tabStatus(true);
    },
    filming_complete() {
      this.tabStatus(true);
    },
    historical_name() {
      this.tabStatus(true);
    },
  },
};
</script>

<style lang="scss">
#color-picker {
  .wrapper-dropdown {
    position: relative;
    width: 100%;
    background: #fff;
    color: #2e2e2e;
    outline: none;
    cursor: pointer;
    > span {
      width: 100%;
      display: block;
      padding: 6px 10px 6px 20px;
      border: 1px solid #dededf;
      border-radius: 0.25rem;
      font-size: 14px;
      font-family: "Lato-Bold";
      color: #000 !important;
      height: 38px;
      > span {
        padding: 0px 12px;
        margin-right: 5px;
        width: calc(100% - 40px);
        display: block;
        height: 24px;
        border-radius: 4px;
      }
      &:after {
        content: "";
        width: 0;
        height: 0;
        position: absolute;
        right: 10px;
        top: calc(50% + 4px);
        margin-top: -6px;
        border-width: 6px 6px 0 6px;
        border-style: solid;
        border-color: #2e2e2e transparent;
      }
    }
    .dropdown {
      position: absolute;
      z-index: 10;
      top: 100%;
      left: 0;
      right: 0;
      background: #fff;
      font-weight: normal;
      list-style-type: none;
      padding-left: 0;
      margin: 0;
      border: 1px solid #ababab;
      border-top: 0;
      padding: 10px 0;
      height: 200px;
      overflow: auto;
      li {
        display: block;
        text-decoration: none;
        color: #2e2e2e;
        padding: 10px 15px;
        cursor: pointer;
        > span {
          padding: 0px 12px;
          margin-right: 5px;
          width: 100%;
          display: block;
          height: 20px;
          border-radius: 4px;
        }
        &:hover {
          background: #eee;
          cursor: pointer;
        }
      }
    }
  }

  &.has-error {
    .wrapper-dropdown {
      & > span {
        border-color: #dc3545;
      }
    }
  }
}
.uppy-Dashboard-inner {
  height: 240px !important;
}
.has-image {
  font-size: 14px;
  .icon {
    margin-left: 10px;
    font-size: 18px;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }
}

.image-wrapper {
  position: relative;
  border-radius: 4px;
  width: 100%;
  background: #d0d0d0;
  height: 240px;
  display: block;
  margin-top: 30px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;

  .actions {
    button,
    span {
      border: 0;
      border-radius: 50%;
      padding: 5px;
      width: 40px;
      height: 40px;
      color: #fff;
      text-align: center;

      &.edit {
        background: rgba(63, 150, 152, 0.7);
        margin: auto;
        display: inline-block;
        &:hover {
          background: rgba(63, 150, 152, 1);
        }
      }
      &.trash {
        background: rgba(219, 40, 40, 0.7);
        bottom: 5px;
        right: 5px;
        &:hover {
          background: rgba(219, 40, 40, 1);
        }
      }
    }
  }

  // button {
  //   position: absolute;
  //   border: 0;
  //   border-radius: 50%;
  //   padding: 5px;
  //   width: 40px;
  //   height: 40px;
  //   color: #fff;

  //   &.edit {
  //     background: rgba(63, 150, 152, 0.7);
  //     top: 0;
  //     bottom: 0;
  //     right: 0;
  //     left: 0;
  //     margin: auto;
  //     &:hover {
  //       background: rgba(63, 150, 152, 1);
  //     }
  //   }
  //   &.trash {
  //     background: rgba(219, 40, 40, 0.7);
  //     bottom: 5px;
  //     right: 5px;
  //     &:hover {
  //       background: rgba(219, 40, 40, 1);
  //     }
  //   }
  // }
}

.file-type-icons {
  position: relative;
  width: 100px;
  button {
    position: absolute;
    border: 0;
    border-radius: 50%;
    padding: 5px;
    width: 40px;
    height: 40px;
    color: #fff;

    &.edit {
      background: rgba(63, 150, 152, 0.7);
      top: 0;
      bottom: 0;
      right: 0;
      left: 0;
      margin: auto;
      &:hover {
        background: rgba(63, 150, 152, 1);
      }
    }
    &.trash {
      background: rgba(219, 40, 40, 0.7);
      bottom: 5px;
      right: 5px;
      &:hover {
        background: rgba(219, 40, 40, 1);
      }
    }
  }
}
</style>

<template>
  <div class="py-5 px-5">
    <div class="container">
      <b-form>
        <div class="row">
          <div class="col-md-6">
            <div class="mb-4">
              <label for="">SERIES</label>
              <multiselect
                v-model="series"
                :options="seriesOptions"
                :close-on-select="false"
                :clear-on-select="false"
                :hide-selected="true"
                :searchable="true"
                placeholder="Type or Select Series"
                label="text"
                track-by="text"
                :create-tag="true"
                :tag="addSeries()"
              >
                <template v-slot:singlelabel="{ value }">
                  <div class="multiselect-single-label" v-if="value">
                    {{ value.text }}
                  </div>
                </template>
              </multiselect>
            </div>
            <b-form-group label="WORKING TITLE" label-for="working_title">
              <b-form-input
                v-model="working_title"
                id="working_title"
                placeholder="Eg: Lorem Ipsum"
                :state="working_title_state"
                aria-describedby="input-live-help input-live-working-title"
              ></b-form-input>
            </b-form-group>
            <label for="">COLOUR</label>
            <div id="color-picker" :class="colour_state ? 'has-error' : ''">
              <div class="wrapper-dropdown">
                <span @click="toggleDropdown()" v-html="selector"></span>
              </div>
              <b-form-group>
                <b-form-input
                  hidden
                  v-model="colour"
                  id="colour"
                ></b-form-input>
              </b-form-group>
            </div>
            <b-form-group
              label="HISTORIC NAME(OPTIONAL)"
              label-for="historical_name"
            >
              <b-form-input
                v-model="historical_name"
                id="historical_name"
                placeholder="Eg.: Fight Back Day 8, Speed & Agility"
              ></b-form-input>
            </b-form-group>

            <div class="mt-4 checkbox-wrapper">
              <b-form-group>
                <b-form-checkbox
                  class="mr-3 text-uppercase"
                  v-model="filming_complete"
                >
                  SCRIPT DONE PRIOR
                </b-form-checkbox>
              </b-form-group>
            </div>
          </div>

          <div class="col-md-6 pl-5">
            <h3 class="text-uppercase">Associated Images</h3>
            <div
              v-if="
                currentActivity.file && !editPortrait && getFileType == 'image'
              "
              class="mt-1 portrait image-wrapper"
              :style="{
                backgroundImage: 'url(\'' + currentActivity.file + '\')',
              }"
            >
              <div class="actions d-flex justify-content-end w-100 p-2">
                <div class="d-flex">
                  <span
                    @click="editPortraitFunc()"
                    class="
                      edit
                      mr-1
                      d-flex
                      justify-content-center
                      align-items-center
                    "
                  >
                    <b-icon icon="pencil" />
                  </span>
                  <span
                    @click="$bvModal.show('image-viewer')"
                    class="
                      edit
                      d-flex
                      justify-content-center
                      align-items-center
                    "
                  >
                    <b-icon icon="eye" />
                  </span>
                </div>
              </div>
            </div>
            <div
              class="file-type-icons"
              v-if="
                currentActivity.file && !editPortrait && getFileType != 'image'
              "
            >
              <img :src="fileWordIcon" v-if="getFileType == 'doc'" />
              <img :src="filePdfIcon" v-if="getFileType == 'pdf'" />
              <span @click="editPortraitFunc()" class="edit">
                <b-icon icon="pencil" />
              </span>
              <a
                class="download"
                :href="currentActivity.file"
                donload="true"
                target="_blank"
              >
                <b-icon icon="cloud" />
              </a>
            </div>
            <inline-file-upload
              v-if="!currentActivity.file || editPortrait"
              :allowMultipleUploads="false"
              v-on:file-uploaded="handleFileUploaded"
            >
            </inline-file-upload>
          </div>
        </div>
      </b-form>
    </div>
    <button
      class="floating-btn btn no-outline"
      @click="createActivity()"
      v-if="!id"
      :disabled="
        currentActivity.working_title == '' ||
        currentActivity.working_title == null ||
        currentActivity.series == '' ||
        currentActivity.series == null ||
        currentActivity.colour == '' ||
        currentActivity.colour == null
          ? true
          : false
      "
    >
      <span class="d-flex justify-content-center align-items-center">
        <img :src="floppyDisk" />
      </span>
    </button>
    <button
      class="floating-btn btn no-outline"
      @click="updateActivity()"
      v-if="id"
      :disabled="
        currentActivity.working_title == '' ||
        currentActivity.working_title == null ||
        currentActivity.series == '' ||
        currentActivity.series == null ||
        currentActivity.colour == '' ||
        currentActivity.colour == null
          ? true
          : false
      "
    >
      <span class="d-flex justify-content-center align-items-center">
        <img :src="floppyDisk" />
      </span>
    </button>
    <b-modal id="image-viewer" hide-header hide-footer>
      <div class="text-right close">
        <span @click="$bvModal.hide('image-viewer')" class="cursor-pointer h3"
          ><b-icon icon="x"
        /></span>
      </div>

      <img :src="currentActivity.file" class="w-100 mt-2" />
    </b-modal>
  </div>
</template>